import { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Text } from '@mantine/core';
import { IconPlayerStop } from '@tabler/icons-react';

function EndNode({ selected }: NodeProps) {
  return (
    <Box
      style={{
        background: '#ef4444',
        border: `2px solid ${selected ? '#374151' : 'transparent'}`,
        borderRadius: '20px',
        padding: '8px 16px',
        minWidth: '100px',
        color: 'white',
        boxShadow: selected ? '0 4px 12px rgba(0, 0, 0, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
      }}
    >
      <Handle type="target" position={Position.Top} />
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          transform: 'translateX(-3px)',
        }}
      >
        <IconPlayerStop size={16} />
        <Text size="sm" fw={700}>
          End
        </Text>
      </Box>
    </Box>
  );
}

export default memo(EndNode);
